'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * Provider of `window.localStorage`, it will detect whether the localStorage
 * is available. If not the callback will not be invoked.
 *
 * @return - what the callback returns
  * */
var localStorageProvider = function localStorageProvider(f) {
  var result = void 0;

  try {
    result = f(window.localStorage);
  } catch (e) {
    console.log('localStorage is not enabled'); // eslint-disable-line no-console
  }

  return result;
};

exports.default = localStorageProvider;